import { useMutation, useQueryClient } from '@tanstack/react-query'

import { type PostPetriReview, usePetriApi } from '@/frontend/hooks/api/use-petri-api'

export function usePostPatientSummaryReview() {
  const petri = usePetriApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (review: PostPetriReview) => petri.postReview(review),
    onSuccess: (_, review) => {
      queryClient.invalidateQueries({
        queryKey: ['patient-summary-review', review.externalId],
      })
    },
  })
}
